<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    try {
      window.initRecordSDK({
        env: 'test'
      });
    } catch (error) {
      window.console.log(error);
    }
  }
};
</script>
<style lang="less">
@import url("./less/mixin.less");
#app {
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // overflow-y: scroll;
  // overflow-x: hidden;
  // -webkit-overflow-scrolling: touch;
  // .bg-image('./img/list_bg');
}
</style>





// WEBPACK FOOTER //
// src/App.vue